var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7961 5.4847C14.1347 5.57805 14.3336 5.92823 14.2402 6.26686L10.986 18.0713C10.8927 18.4099 10.5425 18.6088 10.2039 18.5154C9.86527 18.4221 9.66644 18.0719 9.75979 17.7333L13.014 5.92881C13.1073 5.59019 13.4575 5.39135 13.7961 5.4847ZM16.1154 7.73437C16.3638 7.486 16.7665 7.486 17.0149 7.73437L20.8309 11.5504C21.0792 11.7988 21.0792 12.2015 20.8309 12.4498L17.0149 16.2658C16.7665 16.5142 16.3638 16.5142 16.1154 16.2658C15.867 16.0175 15.867 15.6148 16.1154 15.3664L19.4817 12.0001L16.1154 8.63382C15.867 8.38544 15.867 7.98275 16.1154 7.73437ZM6.98515 7.73437C7.23351 7.486 7.63622 7.486 7.88458 7.73437C8.13294 7.98275 8.13294 8.38544 7.88458 8.63382L4.51829 12.0001L7.88458 15.3664C8.13294 15.6148 8.13294 16.0175 7.88458 16.2658C7.63622 16.5142 7.23351 16.5142 6.98515 16.2658L3.16913 12.4498C2.92076 12.2015 2.92076 11.7988 3.16913 11.5504L6.98515 7.73437Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.d705b97765734a7bd171d9542d07cc84.svg";
export { ForwardRef as ReactComponent };